<template lang="pug">
.v-filter.filter
	.filter__group.filter__group--links.flc(v-if="links")
		.filter__group-title.h4.flc(v-if="variables?.viewTitle" ) {{ variables.viewTitle }}
		.filter__list
			.filter__list-item(v-for="(link, index) in links" :key="index")
				a.filter__link(:href="link.current ? null : link.link" :class="{'filter__link--current': link.current}") {{link.text}}
	.filter__group.filter__group--view.flc(v-if="$slots['view']")
		//.filter__group-title.h4.flc(v-if="variables?.viewTitle" ) {{ variables.viewTitle }}
		.filter__group-body.flc
			slot(name="view")
	.filter__group.filter__group--sort.flc.fcc(v-if="$slots['sort']")
		//.filter__group-title.h4.flc(v-if="variables?.sortTitle" ) {{ variables.sortTitle }}
		.filter__group-body.flc
			slot(name="sort")
	template(v-if="localFilters")
		.filter__group.filter__group--filter.flc.fcc(v-for="(filter, filterIndex) in localFilters"
			:key="filterIndex"
			:style="{width: filter.width || null}")
			.filter__group-title.h4.flc(v-if="filter.title") {{filter.title}}
			.filter__group-body.flc(v-if="filter.type !== 'range' && filter.type !== 'hidden'" )
				v-field(:field="{...filter, disabled: isFilterBlocked(filter.id)}" v-model="filter.value" @update:model-value="filterChange(filter.id)")
			.filter__group-body.flc(v-else-if="filter.type !== 'hidden'")
				v-price-ranger(:field="filter" v-model="filter.value" @update:model-value="filterChange(filter.id)")
	template(v-if="withButton")
		transition(name="fade")
			.filter__actions.flc.fcc(v-if="changedFilters && changedFilters.length")
				.filter__actions-item
					button.btn(type="button" @click="resetAll()") Очистить фильтр
</template>

<script>
export default {
	props: {
		links: {
			type: Array,
			default: null
		},

		withButton: {
			type: Boolean,
			default: null
		},

		filters: {
			type: Array,
			default: null
		},

		variables: {
			type: Object,
			default: null
		}
	},

	emits: [
		'filter-changed',
		'filter-updated'
	],

	data() {
		return {
			localFilters: [],
			filterDebounceTimeout: null,
			lastChangedFilterId: null
		};
	},

	computed: {
		changedFilters() {
			let result = [];
			this.localFilters.forEach((filter) => {
				if (this.isFilterChanged(filter)) {
					result.push(filter);
				}
			});
			return result;
		}
	},

	watch: {
		filters() {
			this.applyNewFilters();
		}
	},

	created() {
		this.applyNewFilters();
	},

	methods: {
		flushPendingChange(emitChange = true) {
			clearTimeout(this.filterDebounceTimeout);
			this.lastChangedFilterId = null;
			const value = this.createValue();
			if (emitChange) {
				this.$emit('filter-changed', value, this.changedFilters);
			}
			return value;
		},

		isFilterChanged(filter) {
			if (typeof filter.value == 'number' ||
					(filter.value && filter.value.length && filter.value.length > 0) ||
					(filter.type === 'range' && filter.value && ((filter.value.min > filter.min) || (filter.value.max < filter.max)) ) ||
					(filter.type === 'range-slider' && filter.value && ((filter.value.min > filter.min) || (filter.value.max < filter.max)) )) {
				return true;
			}
			return false;
		},

		isFilterBlocked(filterId) {
			return this.lastChangedFilterId && this.lastChangedFilterId !== filterId || this.localFilters.find((item) => item.id === filterId)?.disabled;
		},

		applyNewFilters() {
			let tmpFilters = [];
			this.filters.forEach((filter) => {
				let oldFilter = this.localFilters.find((item) => item.id === filter.id);
				filter.open = oldFilter ? oldFilter.open : !!filter.open;
				tmpFilters.push(filter);
			});
			this.localFilters = JSON.parse(JSON.stringify(tmpFilters));
			this.$emit('filter-updated', this.createValue(), this.changedFilters);
		},

		resetFilter(options) {
			let filter = this.localFilters.find((filter) => filter.id === options.id);
			if (!filter) {
				return;
			}
			if (filter.type === 'range' || filter.type === 'range-slider') {
				filter.value.min = filter.min;
				filter.value.max = filter.max;
			} else {
				if (options.value && Array.isArray(filter.value)) {
					filter.value.splice(filter.value.indexOf(options.value), 1);
				} else {
					filter.value = [];
				}
			}
			if (!options.silent) {
				this.filterChange();
			}
		},

		resetAll() {
			this.localFilters.forEach((filter) => {
				this.resetFilter({id: filter.id, silent: true});
			});
			this.filterChange();
		},

		createValue() {
			let result = {};
			this.changedFilters.forEach((filter) => {
				result[filter.id] = {value: filter.value, type: filter.type};
			});
			return result;
		},

		filterChange(filterId) {
			this.lastChangedFilterId = filterId;
			clearTimeout(this.filterDebounceTimeout);
			this.filterDebounceTimeout = setTimeout(() => {
				this.flushPendingChange();
			}, 500);
		}
	}
};
</script>
